import fetcher from "@helper/fetcher";
import { getWindowOrigin } from "@helper/utils";
import useSWR, { SWRResponse } from "swr";

export default function useSwrApi<T>(endpoint: string): SWRResponse<T, Error> {
  const url = `${getWindowOrigin()}/_plat/api/v1/${endpoint}`;
  const swrRes: SWRResponse<T, Error> = useSWR<T, Error>(url, fetcher, {
    onError: (error) => {
      console.error(`Error fetching data from ${url}:`, error);
    },
  });
  return swrRes;
}
